
import { Component, Prop, Vue } from 'vue-property-decorator'

const referrers = [
  'applicant_count',
  'application_status',
  'credibility',
  'header_navigation',
  'recommended_view',
  'no_requirements_view',
  'initial',
  'application_status_view',
  'automatically_reapply',
  'payment',
  'similarity_view',
  'reactivate_apply'
] as const

export type Referrer = typeof referrers[number];

const eventByReferrer = {
  [referrers[0]]: 'Unlock feature tooltip [applicant count]', //
  [referrers[1]]: 'Status tooltip',
  [referrers[2]]: 'Unlock feature tooltip [credibility]', //
  [referrers[3]]: 'Reactivate pro button navigation', //
  [referrers[4]]: 'Reactivate pro button recommended', //
  [referrers[5]]: 'Recurring no requirement screen',
  [referrers[6]]: 'Welcome',
  [referrers[7]]: 'Application sent screen',
  [referrers[8]]: 'Automatically reapply tooltip',
  [referrers[9]]: 'Unlock feature tooltip [payment]', //
  [referrers[10]]: 'Similarity sent screen',
  [referrers[11]]: 'Reactivate pro button details' //
}

// Unlock feature tooltip, Reactivate pro button navigation, Reactivate pro button recommended, Reactivate pro button details

@Component
export default class ApplyReactivate extends Vue {
  @Prop({ type: Boolean, default: false }) showIfPro!: boolean
  @Prop({ type: String, default: '' }) referrer: Referrer
  @Prop({ type: String, default: '' }) eventName!: string

  get isMob() {
    return this.$accessor.screen.resolution < 768
  }

  get isPro() {
    return !!this.$auth.user.membership && !this.$auth.user.membership?.freemium && !this.isMaintenanceMode
  }

  get isMaintenanceMode() {
    return this.$auth.user.membership?.isMaintenanceModeHasEffect || this.$auth.user.membership?.isMaintenanceMode
  }

  get maxWidth() {
    return this.isMob
      ? '375px'
      : '855px'
  }

  openModal(referrer: Referrer) {
    this.$modal.show(
      Vue.component('ReactivateProModal'),
      {
        openedFrom: eventByReferrer[referrer] || ''
      },
      {
        width: this.maxWidth,
        scrollable: true,
        name: 'reactivate-pro-modal'
      })
  }

  click() {
    if (this.eventName) {
      const props = this.$route.params.cardId
        ? { scholarshipId: Number(this.$route.params.cardId) }
        : null

      this.$mixpanel.track(
        this.eventName,
        this.$mixpanel.fillProps(this.eventName, props)
      )
    }

    this.openModal(this.referrer)
  }
}
